import { useState, useEffect } from 'react';
import { ChevronRight } from 'lucide-react';
import nhost from '../nhost';

const MEMBERS_QUERY = `
  query {
    profiles(where: { approved: { _eq: true } }, order_by: { display_name: asc }) {
      id display_name avatar_url created_at last_seen
    }
  }
`;

const divider = { borderTop: '1px solid rgba(60,20,30,.07)' };

export default function MembersModal({ profile, onClose, onViewMember }) {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    nhost.graphql.request(MEMBERS_QUERY).then(({ data }) => {
      if (data) setMembers(data.profiles);
      setLoading(false);
    });
  }, []);

  function onlineStatus(lastSeen) {
    if (!lastSeen) return null;
    const diff = (Date.now() - new Date(lastSeen)) / 1000 / 60;
    if (diff < 5) return { color: '#4CAF50', label: 'Online' };
    if (diff < 60) return { color: '#FFC107', label: `${Math.round(diff)} min sedan` };
    return null;
  }

  const onlineCount = members.filter(m => m.last_seen && (Date.now() - new Date(m.last_seen)) / 1000 / 60 < 5).length;

  return (
    <div className="modal-bg" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-handle" />
        <div className="modal-title">Medlemmar</div>

        {onlineCount > 0 && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#1F8A5B', fontWeight: 500, marginBottom: 14, background: '#E1F5EE', borderRadius: 20, padding: '5px 12px', width: 'fit-content' }}>
            <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#1F8A5B' }} />
            {onlineCount} {onlineCount === 1 ? 'person' : 'personer'} online nu
          </div>
        )}

        {loading ? (
          <div style={{ textAlign: 'center', padding: 20, color: 'var(--muted)', fontSize: 13 }}>Laddar...</div>
        ) : (
          <div style={{ background: '#fff', border: '1px solid rgba(60,20,30,.08)', borderRadius: 14, overflow: 'hidden', marginBottom: 14 }}>
            {members.map((m, i) => {
              const status = onlineStatus(m.last_seen);
              return (
                <div
                  key={m.id}
                  onClick={() => { onClose(); onViewMember(m.id); }}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 12,
                    padding: '11px 14px',
                    ...(i > 0 ? divider : {}),
                    cursor: 'pointer',
                  }}
                >
                  <div style={{ position: 'relative', flexShrink: 0 }}>
                    <div style={{
                      width: 40, height: 40, borderRadius: '50%',
                      background: 'var(--wine-light)',
                      overflow: 'hidden',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      border: '1px solid rgba(60,20,30,.08)',
                    }}>
                      {m.avatar_url ? (
                        <img src={m.avatar_url} alt={m.display_name} loading="lazy" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      ) : (
                        <span style={{ fontSize: 17, color: 'var(--wine)', fontFamily: 'var(--font-display)', fontWeight: 600 }}>
                          {m.display_name?.[0]}
                        </span>
                      )}
                    </div>
                    {status && (
                      <div style={{ position: 'absolute', bottom: 1, right: 1, width: 10, height: 10, borderRadius: '50%', background: status.color, border: '2px solid white' }} />
                    )}
                  </div>

                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 14, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 5, flexWrap: 'wrap' }}>
                      {m.display_name}
                      {m.id === profile.id && <span style={{ fontSize: 10, color: 'var(--muted)', fontWeight: 400 }}>(du)</span>}
                      {status && (
                        <span style={{ fontSize: 10, color: status.color, fontWeight: 500 }}>{status.label}</span>
                      )}
                    </div>
                    <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>
                      Medlem sedan {new Date(m.created_at).toLocaleDateString('sv-SE', { year: 'numeric', month: 'long' })}
                    </div>
                  </div>

                  <ChevronRight size={16} color="var(--muted)" strokeWidth={1.7} style={{ flexShrink: 0 }} />
                </div>
              );
            })}
          </div>
        )}

        <button
          onClick={onClose}
          style={{ width: '100%', background: '#fff', color: 'var(--ink)', border: '1px solid rgba(60,20,30,.12)', borderRadius: 12, padding: '11px', fontSize: 14, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit' }}
        >
          Stäng
        </button>
      </div>
    </div>
  );
}
